function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M33.5 10.9s1.2 1.4 2.8 1.4c.7 0 1.3-.3 1.3-.9 0-1.3-4.9-1.3-4.9-4.3 0-1.9 1.7-2.7 3.6-2.7 1.3 0 3.3.4 3.3 1.9v1h-2.1v-.5c0-.4-.7-.7-1.2-.7-.8 0-1.3.3-1.3.9 0 1.5 5 1.2 5 4.3 0 1.8-1.6 2.9-3.6 2.9-2.6 0-3.9-1.7-3.9-1.7l1-1.6zM45.4 4.3c2.7 0 4.1 2 4.1 4.4v.9H43c.2 1.6 1.4 2.5 2.8 2.5 1.5 0 2.6-1 2.6-1l1.2 1.5s-1.6 1.6-3.9 1.6c-3.1 0-5-2.2-5-4.9 0-3 1.9-5 4.7-5zM47.2 8c0-1.1-.8-1.9-1.8-1.9-1.2 0-2 .7-2.3 1.9h4.1zM51.4 6.2H50V4.3h1.4V2h2.1v2.3h2.3v1.8h-2.3v4c0 1.8 1.4 1.9 2 1.9h.4v2s-.3.1-.7.1c-1.3 0-3.9-.4-3.9-3.5V6.2zM26.8 11.1c-.1 0-.1.1-.1.1v.3H26v-.8c0-.3.1-.4.4-.4H27.8c-.3-.2-.6-.6-.6-1.1 0-.7.4-1.1 1.2-1.1h1.3c.1 0 .1-.1.1-.1v-.3h.7v.8c0 .3-.1.4-.4.4h-1.5c-.4 0-.7.1-.7.5s.3.8.7.9c.1 0 .3.1.4.1h1.5v.8h-3.7zM1.1 10.9s1.2 1.4 2.8 1.4c.7 0 1.3-.3 1.3-.9 0-1.3-4.9-1.3-4.9-4.3C.3 5.2 2 4.4 3.9 4.4c1.3 0 3.3.4 3.3 1.9v1H5.1v-.5c0-.4-.7-.7-1.2-.7-.8 0-1.4.3-1.4.9 0 1.5 5 1.2 5 4.3 0 1.8-1.6 2.9-3.6 2.9-2.6 0-3.9-1.7-3.9-1.7l1.1-1.6zM13 4.3c2.7 0 4.1 2 4.1 4.4v.9h-6.5c.2 1.6 1.4 2.5 2.8 2.5 1.5 0 2.6-1 2.6-1l1.2 1.5s-1.6 1.6-3.9 1.6c-3.1 0-5-2.2-5-4.9-.1-3 1.9-5 4.7-5zM14.7 8c0-1.1-.8-1.9-1.8-1.9-1.2 0-2 .7-2.3 1.9h4.1zM18.9 6.2h-1.4V4.3H19V2h2.1v2.3h2.3v1.8h-2.3v4c0 1.8 1.4 1.9 2 1.9h.4v2s-.3.1-.7.1c-1.3 0-3.9-.4-3.9-3.5V6.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M27.5 13.6v.5h-.7v-.5H26v-.8h.9v-.9h.7v.9H29c.7 0 .7-.5.7-.8v-.2h.8v.3c0 .5-.1 1.5-1.3 1.5h-1.7z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M26.8 5.9c0-1 .7-1.6 1.7-1.6h.3v2.4c.6-.1.9-.5.9-1 0-.6-.4-1-.4-1l.6-.4s.6.6.6 1.5c0 1.2-.8 1.9-1.8 1.9-1.1 0-1.9-.8-1.9-1.8zm1.4-.7c-.4 0-.7.3-.7.7 0 .4.3.8.7.9V5.2z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 8,
  r: 8,
  fill: "#39a4a1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#105568",
  d: "M72.8 12.4s1 1.7 1.5 1c0 0 .2-1.6.1-10.4l-10.8-.1V14c.9.8 2 1.4 3.2 1.8.6-.1 3.2-.4 6-3.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M74.2 13.4c-3.8 2.1-7.6 2.4-7.5 2.4 3.8-.7 6-3.4 6-3.4 1.1 1.2 1.5 1 1.5 1zM67.8 8.3c0-.9-.8-1.5-1.6-1.5-.9 0-1.5.8-1.5 1.6 0 .9.8 1.5 1.6 1.5.9 0 1.5-.7 1.5-1.6zm-.7.2c-.1.1-1.2.8-1.2.8-.1 0-.2-.1-.2-.2V7.6c0-.1.1-.2.2-.2l1.2.8c0 .1.1.2 0 .3zM65.87 2.777l5.89-.345.075 1.298-5.89.345zM68.7 7.1h4v.4h-4zM68.7 8.2h4v.4h-4zM68.7 9.4h4v.4h-4z"
}));

var SvgLightLogoSmall = function SvgLightLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 16.1,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LightLogoSmall.e9d68214.svg";
export { ForwardRef as ReactComponent };